module.exports = __webpack_public_path__ + "static/Załącznik nr 2 do REGULAMINU-4e5710601872541bd8302b77aec205ee.pdf";